module.exports = __webpack_public_path__ + "static/img/img_wtwz.493d8059.png";